<tt-page>
    <tt-page-heading>{{ heading }}</tt-page-heading>
    <tt-email-create [params]="params" (getLoaded)="setHeading($event)" (submit)="onSubmit()"></tt-email-create>
</tt-page>
